<template>
  <div class="poster-container">
    <div class="content">
      <p v-if="title" class="title">{{ title }}</p>
      <button aria-label="Play video" class="play" @click="$emit('play')"><PlayIcon /></button>
      <span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
    </div>

    <AppImage :image="image" :blurred-preview="imageBlur" class="video-poster" />
  </div>
</template>

<script>
export default {
  name: 'AppVideoVideo',
  components: {
    PlayIcon: () => import('@/components/icons/PlayIcon'),
    AppImage: () => import('@/components/common/AppImage'),
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    imageBlur: {
      type: String,
      default: '',
    },
    posterUrl: {
      type: String,
      default: '/about-us-poster.jpg',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    withoutLazy: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/common/AppVideoPoster';
</style>
